exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".row[_v-519a3c08]{margin:0}@media (max-width:768px){.container[_v-519a3c08]{text-align:center}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-519a3c08&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Product/Product-detail-info.vue
// module id = 433
// module chunks = 0